import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { RoleManagementList } from '@/components/pages/Admin/RoleManagement/List'
import { useTranslations } from '@/hooks/useTranslations'
import { LinkButton } from '@/components/ui'

export const Route = createFileRoute('/(dashboard)/admin/role/')({
  component: RolePage,
})

function RolePage() {
  const t = useTranslations('admin.role_management')

  return (
    <HomeContentContainer title={t('title')} rightContent={<LinkButton to="/admin/role/create">สร้างบทบาท</LinkButton>}>
      <RoleManagementList />
    </HomeContentContainer>
  )
}

